import React, { useState } from 'react';
import { Menu, MenuItem } from '@mui/material';
import ButtonUI from './ButtonUI';

const DropDownUI = (props) => {
  const { options = [], onSelect } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (option) => {
    setAnchorEl(null);
    if (option && onSelect) {
      onSelect(option);
    }
  };

  return (
    <>
      <ButtonUI variant="contained" onClick={handleClick} {...props} className="bg-labelColor"></ButtonUI>
      <Menu anchorEl={anchorEl} open={open} onClose={() => handleClose(null)} {...props}>
        {options.map((option) => (
          <MenuItem key={option.value} onClick={() => handleClose(option)} disabled={option?.disabled}>
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default DropDownUI;
